export default "__VITE_ASSET__Xy7XldQK__"